import {
    RestNewFollowupQuestionListServiceUpdatePatientAnswerInfoById, //更新答案
    RestNewFollowupQuestionListServiceAddPatientAnswerInfo,
    RestNewFollowupQuestionListServiceQueryQuestionPageList, //查询页码信息
    RestNewFollowupQuestionListServiceAddPatientQuestionnaireAnswer, //新增患者问卷答题表
    RestNewFollowupQuestionListServiceUpdatePatientQuestionnaireAnswer,
    RestNewFollowupQuestionListServiceQueryPageAndQuestionList,
    RestNewFollowupQuestionListServiceFillTelQuestionnaireNewAnswer,
    RestNewFollowupQuestionListServiceGetQuestionnairePageList,
    RestNewFollowupQuestionListServiceDelAnswerOptionById,
    RestNewFollowupQuestionListServiceBatchAddPatientAnswerInfo,// 批量提交接口
} from "@src/assets/js/api.js"

var LocalAnswe = {}
const actions = {
    getFollowupStatus({commit},params) {
        let followUpStatus = [
            {label: '短信随访未开始', value: 1},
            {label: '短信发送1次', value: 2},
            {label: '短信发送2次', value: 3},
            {label: '短信转电话随访', value: 4},
            {label: '短信随访完成', value: 5},
            {label: '随访待开始', value: 6},
            {label: '电话随访未完成', value: 7},
            {label: '电话随访稍后拨打', value: 8},
            {label: '电话随访完成', value: 9},
            {label: '失访', value: 10},
            {label: '未成功', value: 11},
            {label: '死亡', value: 12},
            {label: '异常号码', value: 13},
            {label: '沟通不畅', value: 16},
            {label: '拒绝随访（有信息）', value: 17},
            {label: '拒绝随访（无信息）', value: 18},
        ]
        return followUpStatus.find(item => item.value == params.status) ? followUpStatus.find(item => item.value == params.status).label : '-'
    },

    //进入问卷页面迪奥此接口
    async deleteQuestionAnswer({commit}, p) {
        // let request = new RestNewFollowupQuestionListServiceDelAnswerOptionById()
        // request.p_questionnaireNewId = p.questionNewId
        // request.p_patientAnswerInfoId = p.answerInfoId
        // await request.send()
        // return request.result
    },
    //进入问卷页面迪奥此接口
    async fillTelQuestionnaireNewAnswer({commit}, p) {
        let request = new RestNewFollowupQuestionListServiceFillTelQuestionnaireNewAnswer()
        console.log('questionnaireNewId---->',p.questionnaireNewId)
        request.p_followupPatientId = p.followupPatientId
        request.p_questionnaireNewId = p.questionnaireNewId
        await request.send()
        return request.result
    },
    //查询页码和题目标题属性列表
    async getPageAndQuestionList({commit}, p) {
        let request = new RestNewFollowupQuestionListServiceQueryPageAndQuestionList()
        request.p_questionnaireNewId = p.questionId
        await request.send()
        return request.result
    },
    //获取分页
    async getQuestionnairePageList({commit}, p) {
        let request = new RestNewFollowupQuestionListServiceGetQuestionnairePageList()
        request.p_questionnaireNewId = p.questionId
        await request.send()
        return request.result
    },
    //进入预览填写状态id获取
    async addPatientQuestionAnswer({commit}, p) {
        let request = new RestNewFollowupQuestionListServiceAddPatientQuestionnaireAnswer()
        request.p_followupPatientId = p.followupPatientId
        request.p_questionnaireNewId = p.questionnaireNewId
        await request.send()
        return request.result
    },
    //问卷答完更新id
    async updatePateintQuestionAnswer({commit}, p) {
        let request = new RestNewFollowupQuestionListServiceUpdatePatientQuestionnaireAnswer()
        request.p_finish = p.finish
        request.p_followupPatientId = p.followupPatientId
        request.p_id = p.id
        request.p_questionnaireNewId = p.questionnaireNewId
        await request.send()
        if(request.result.status == 0) {

        }else {
                alert('保存失败')
        }
        return request.result
    },
    async saveQuestionAnswer({commit}, p) {
        console.log(p);
        let request = new RestNewFollowupQuestionListServiceAddPatientAnswerInfo()
        request.p_answerInfo = p.answerInfo
        request.p_operatorId = sessionStorage.getItem('userid')
        request.p_questionInfo = p.questionInfo
        request.p_questionnaireNewId = p.questionnaireNewId
        request.p_followupPatientId = p.patientId
        request.p_isRecord = p.isRecord
        request.p_sourceType = 2
        request.p_questionType = p.questionType

        await request.send()
        if (request.result.status == 0 ) {
            // LocalAnswe[p.questionInfo] = p.answerInfo
            // actions.updateBatchAnswer({commit}, p)
        }else {
                alert('保存失败')
        }
        return request.result
    },
    async updateQuestionAnswer({commit}, p) {
        // let request = new RestNewFollowupQuestionListServiceAddPatientAnswerInfo()
        // request.p_answerInfo = p.answerInfo
        // request.p_operatorId = sessionStorage.getItem('userid')
        // request.p_questionInfo = p.questionInfo
        // request.p_questionnaireNewId = p.questionnaireNewId
        // request.p_id = p.id
        // request.p_followupPatientId = p.patientId
        // request.p_isRecord = p.isRecord
        // request.p_sourceType = 2
        // request.p_questionType = p.questionType
        //
        // await request.send()
        // console.log(request.result);
        // if (request.result.status == 0 && !request.result.retValue) {
        //     // LocalAnswe[p.questionInfo] = p.answerInfo
        //     // actions.updateBatchAnswer({commit}, p)
        // }
        // return request.result
    },
    async queryQuestionPageListAsync({commit}, p) {
        let request = new RestNewFollowupQuestionListServiceQueryQuestionPageList()
        request.p_questionPageResp = p.questionPageResp
        await request.send()
        return request.result
    },
    async updateBatchAnswer({commit}, p) {
        if(!p.list.length) {
            return
        }
        let request = new RestNewFollowupQuestionListServiceBatchAddPatientAnswerInfo()
        request.p_batchAnswerInfoList = p.list
        request.p_taskId = p.taskId
        request.p_isRecord = p.isRecord || false
        await request.send()
        return request.result

    }
}

export default {
    actions
}